<div>
  <gstar-combobox
    [label]="title"
    [options]="countries()"
    keyProp="name"
    [required]="required()"
    valueProp="countryId"
    [value]="value"
    [disabled]="disabled"
    (clearValue)="clearCountryHandler()"
    (selectItem)="selectCountryHandler($event)" />
</div>
